$(function ($) {

  $('.subcategories-wrapper .active a').on('click', function(e) {
    e.preventDefault();

    $(this).closest('.subcategories-wrapper').toggleClass('is-open');
  });

});
